import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-auth-callback',
  template: '<main class="callback-page" aria-live="polite">Completing sign-in…</main>',
  styles: [':host { display: grid; min-height: 100dvh; place-items: center; } .callback-page { color: #53627b; font: 500 1rem/1.5 system-ui, sans-serif; }'],
})
export class AuthCallbackComponent {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  constructor() {
    void this.complete();
  }

  private async complete(): Promise<void> {
    await this.auth.waitUntilInitialized();
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    await this.router.navigateByUrl(this.auth.user() && returnUrl?.startsWith('/') ? returnUrl : '/chat');
  }
}
